define('SageDotCom/Components/DynamicProductCard/BundlePriceBox',["jquery",
    "eventManager",
    "SageDotCom/Components/ProductCardAlignment",
    "SageDotCom/Utility/sanitizer"],
    function ($, eventManager, productCardAlignment, sanitizer) {
        function BundlePriceBox(scope, productSku, promoLabel, isPreview) {
            let locale = undefined;
            let productListPrice = undefined;
            const productCard = $(scope).parents(".sage-product-card-outer");
            const dynamicButtons = productCard.find(".dynamic-product-card-bundle-buy-btn");
            const priceBox = $(scope).find(".sage-product-card-bundle-price-box");

            if (isPreview) {
                const currentUrl = new URL(window.location.href);
                locale = currentUrl.searchParams.get('sc_lang');
            }

            if (typeof (locale) === "undefined") {
                const localeArr = document.location.pathname.split("/");
                for (let i = 0; i < localeArr.length; i++) {
                    if (localeArr[i] !== "") {
                        locale = localeArr[i];
                        break;
                    }
                }
            }

            const repopulatePriceBox = function (selectedSku, productName) {
                //Switch everything off until appropriate data is received
                dynamicButtons.removeAttr("href");
                dynamicButtons.hide();
                priceBox.hide();

                $.ajax({
                    type: "GET",
                    url: `/sitecore/api/product/DynamicBundlePriceBoxData/${productSku}/${selectedSku}/${locale}`,
                    context: this,
                    data: {
                        promoHtmlTemplate: sanitizer.sanitizeHtml(promoLabel)
                    }
                }).done(function (response) {
                    if (response !== "") {
                        const jsonObj = JSON.parse(response);
                        productListPrice = jsonObj.FormattedPrice;

                        $(scope).find(".price-pre-text").text(jsonObj.Name);
                        $(scope).find(".sage-product-card-price-alt").html(productListPrice);

                        if (jsonObj.Promo) {
                            jsonObj.Promo.PromoHtml = sanitizer.sanitizeHtml(jsonObj.Promo.PromoHtml)
                            $(scope).find(".sage-dynamic-product-card-promotion-banner").html(jsonObj.Promo.PromoHtml);
                            $(scope).find(".sage-dynamic-product-card-promo").html(jsonObj.Promo.PromoHtml).show();
                            $(scope).find(".sage-dynamic-product-card.sage-product-card-price-box").addClass("promo");
                        }
                        else {
                            $(scope).find(".sage-dynamic-product-card-promotion-banner").html("");
                            $(scope).find(".sage-dynamic-product-card-promo").html("").hide();
                            $(scope).find(".sage-dynamic-product-card.sage-product-card-price-box").removeClass("promo");
                        }

                        //Handle the button hrefs
                        dynamicButtons.attr("href", jsonObj.BuyUrl);

                        priceBox.show();
                        dynamicButtons.show();

                        // repopulate comparison table header if Bundle Price Box component is inside comparison table
                        if ($(scope).parents(".product-comparison-table") !== null && $(scope).parents(".product-comparison-table").length > 0) {
                            eventManager.trigger("populate-comparison-header", jsonObj.Name, $(scope), true);
                        }

                        productCardAlignment.sageProductCardMatchHeight();
                    }
                });
            }

            eventManager.subscribe("multi-step-panel-change", function (panelId, sku, productName) {
                repopulatePriceBox(sku, productName);
            });
        }

        BundlePriceBox.init = function init(args) {
            return args.IsEditorEditing === true
                ? null
                : new BundlePriceBox(args.scope, args.productSku, args.promoLabel, args.isPreview);
        };

        return BundlePriceBox;
    });
